<template>
  <div class="window-selection">
    <h4 class="flex-row-align-center" @click="toggleQuickOptions">
      <strong>{{
        getSelectedTime ||
        getActiveTimeForDisplayViaProps ||
        getActiveTimeForDisplay ||
        `Select Time Window`
      }}</strong>
      <Icon size="18" @click="toggleQuickOptions">insert_invitation</Icon>
    </h4>

    <component
      v-bind:is="dropup ? 'SlideYDownTransition' : 'SlideYUpTransition'"
    >
      <div
        v-if="showQuickOptions"
        v-click-outside="closeQuickOptions"
        ref="options"
        :class="['options', 'shadow-down', { dropup: dropup }]"
      >
        <div
          class="option"
          v-for="option in quickOptions"
          :key="option.id"
          @click="selectQuickOption(option)"
        >
          <p class="ellipsis">{{ option.name }}</p>
        </div>
      </div>
    </component>

    <SlideYDownTransition>
      <div
        v-if="showQuickOptions"
        v-click-outside="closeQuickOptions"
        ref="options"
        :class="['options', 'shadow-down', { dropup: true }]"
      >
        <div
          class="option"
          v-for="option in quickOptions"
          :key="option.id"
          @click="selectQuickOption(option)"
        >
          <p class="ellipsis">{{ option.name }}</p>
        </div>
      </div>
    </SlideYDownTransition>

    <SlideYDownTransition>
      <PopupBackground v-if="showCustomPicker" @click="closePopup">
        <Card @onClickCancel="closePopup" @onClickApply="applyDateTime" medium>
          <div class="time-filters-window">
            <h2 class="title">Filters</h2>
            <!-- Date range picker -->
            <div class="section-header">
              <h4 class="section-title">
                <icon>linear_scale</icon>Time Window
              </h4>
            </div>
            <DateRangePicker v-model="tempSelectedDate" />
            <!-- Day selector -->
            <div class="section-header" @click="toggleDaySelection">
              <h4 class="section-title">
                <icon>today</icon>Show only for Days
              </h4>
              <icon
                :class="[{ rotate: showDaySelection }]"
                type="button"
                @click="toggleDaySelection"
                >keyboard_arrow_down</icon
              >
            </div>
            <transition name="slide">
              <DaysSelection
                v-if="showDaySelection"
                v-model="tempSelectedDays"
              />
            </transition>
            <!-- Time range selection -->
            <div class="section-header" @click="toggleTimeSelection">
              <h4 class="section-title">
                <icon>timelapse</icon>Show only for time between
              </h4>
              <icon
                :class="[{ rotate: showTimeSelection }]"
                type="button"
                @click="toggleTimeSelection"
                >keyboard_arrow_down</icon
              >
            </div>
            <transition name="slide">
              <PeakTimeSelection
                v-if="showTimeSelection"
                v-model="tempSelectedPeaks"
              />
            </transition>
          </div>
        </Card>
      </PopupBackground>
    </SlideYDownTransition>
  </div>
</template>
<script>
import PopupBackground from "@/components/modals/PopupBackground";
import Card from "@/components/datetimepicker/containers/Card";
import DaysSelection from "@/components/datetimepicker/views/DaysSelection";
import PeakTimeSelection from "@/components/datetimepicker/views/PeakTimeSelection";
import DateRangePicker from "@/components/datetimepicker/views/DateRangePicker";
import { SlideYDownTransition, SlideYUpTransition } from "vue2-transitions";
import moment from "@/lib/moment";
import { mapGetters } from "vuex";
export default {
  props: {
    getSelectedTime: String,
    getActiveTimeForDisplayViaProps: String,
    getActiveTimeWindow: Array,
    dropup: { type: Boolean, default: true },
  },
  components: {
    PopupBackground,
    Card,
    DaysSelection,
    DateRangePicker,
    PeakTimeSelection,
    SlideYDownTransition,
    SlideYUpTransition,
  },
  data() {
    return {
      selectedDate: null,
      selectedDays: [],
      selectedPeaks: [],
      tempSelectedDate: [null, null],
      tempSelectedDays: [],
      tempSelectedPeaks: [],
      showDaySelection: false,
      showTimeSelection: false,
      showCustomPicker: false,
      showQuickOptions: false,
      quickOptions: [
        { id: "last_3hours", name: "Last 3 Hours" },
        // { id: "today", name: "Today" },
        // { id: "yesterday", name: "Yesterday" },
        { id: "last_1day", name: "Last 1 Day" },
        { id: "last_7days", name: "Last 7 Days" },
        // { id: "week", name: "Last Week" },
        // { id: "month", name: "Last Month" },
        { id: "last_1month", name: "Last Month" },
        { id: "last_3months", name: "Last 3 Months" },
        { id: "custom", name: "Customize" },
      ],
    };
  },
  computed: {
    // ...mapGetters("TimeManager", ["getMaxDBTime"]),
    ...mapGetters("Time", ["getMaxDBTime"]),
    getActiveTimeForDisplay() {
      if (this.selectedDate && this.selectedDate.length > 0) {
        const t_start = this.selectedDate[0];
        const t_end = this.selectedDate[1];
        let startTime = moment(t_start).format("DD/MM/YY h:mm a");
        let endTime = moment(t_end).format("DD/MM/YY h:mm a");
        return `${startTime} to ${endTime}`;
      } else {
        return null;
      }
    },
  },
  methods: {
    closePopup() {
      this.tempSelectedDate = this.selectedDate || [null, null];
      this.tempSelectedDays = this.selectedDays || [];
      this.tempSelectedPeaks = this.selectedPeaks || [];
      this.showCustomPicker = false;
    },
    toggleQuickOptions() {
      this.showQuickOptions = !this.showQuickOptions;
    },
    closeQuickOptions() {
      this.showQuickOptions = false;
    },
    getMinimalDate(epochs) {
      if (!epochs) return null;
      let date = new Date(epochs);
      date = new Date(date.getFullYear(), date.getMonth(), date.getDate());
      return date.getTime();
    },
    selectQuickOption(option) {
      let startTime, endTime;
      let pointOfRef = this.getMaxDBTime || new Date();
      switch (option.id) {
        // case "today": {
        //   startTime = moment(pointOfRef).startOf("day");
        //   endTime = moment(pointOfRef).endOf("day");
        //   break;
        // }
        // case "yesterday": {
        //   startTime = moment(pointOfRef).subtract(1, "day").startOf("day");
        //   endTime = moment(pointOfRef).subtract(1, "day").endOf("day");
        //   break;
        // }
        case "last_3hours": {
          startTime = moment(pointOfRef).subtract(3, "hour");
          endTime = moment(pointOfRef);
          break;
        }
        case "last_1day": {
          startTime = moment(pointOfRef).subtract(1, "day");
          endTime = moment(pointOfRef);
          break;
        }
        case "last_7days": {
          startTime = moment(pointOfRef).subtract(1, "week");
          endTime = moment(pointOfRef);
          break;
        }
        // case "week": {
        //   startTime = moment(pointOfRef).subtract(1, "week").startOf("week");
        //   endTime = moment(pointOfRef).subtract(1, "week").endOf("week");
        //   break;
        // }
        // case "month": {
        //   startTime = moment(pointOfRef).subtract(1, "month").startOf("month");
        //   endTime = moment(pointOfRef).subtract(1, "month").endOf("month");
        //   break;
        // }
        case "last_1month": {
          startTime = moment(pointOfRef).subtract(1, "month");
          endTime = moment(pointOfRef);
          break;
        }
        case "last_3months": {
          startTime = moment(pointOfRef).subtract(3, "month");
          endTime = moment(pointOfRef);
          break;
        }
        case "custom": {
          this.showQuickOptions = false;
          this.showCustomPicker = true;
          break;
        }
      }
      if (startTime && endTime) {
        this.showQuickOptions = false;
        this.tempSelectedDate = [+startTime.format("x"), +endTime.format("x")];
        this.tempSelectedDays = [];
        this.tempSelectedPeaks = [];
        this.applyDateTime();
      }
    },
    applyDateTime() {
      // TODO: Test this for bugs, shouldn't there be an { }
      if (
        this.tempSelectedDate &&
        this.tempSelectedDate.length == 2 &&
        this.tempSelectedDate[0] &&
        this.tempSelectedDate[1]
      )
        this.selectedDate = this.tempSelectedDate;
      this.selectedDays = this.tempSelectedDays;
      this.selectedPeaks = this.tempSelectedPeaks;
      this.$emit("saveTimeFilters", {
        selectedDate: this.selectedDate,
        selectedDays: this.selectedDays,
        selectedPeaks: this.selectedPeaks,
      });
      this.closePopup();
    },
    toggleDaySelection() {
      this.showDaySelection = !this.showDaySelection;
    },
    toggleTimeSelection() {
      this.showTimeSelection = !this.showTimeSelection;
    },
  },
  watch: {
    getActiveTimeWindow: {
      immediate: true,
      handler(value) {
        // If getActiveTimeWindow is passed via prop (coming from store) and the value is valid:
        if (value && value.length == 2) {
          this.selectedDate = value;
          this.tempSelectedDate = value;
        }
      },
    },
  },
};
</script>
<style lang="scss" scoped>
.window-selection {
  display: flex;
  align-items: center;
  background: var(--border-color);
  padding: 5px 10px;
  border-radius: 5px;
  transition: 0.3s all ease-in-out;
  position: relative;
  i {
    margin: 0;
    padding-left: 10px;
  }

  &:hover {
    cursor: pointer;
    background: var(--color-primary-light);
    > h4 {
      color: var(--color-primary);
    }
  }
  .options {
    position: absolute;
    width: 100%;
    background: var(--color-secondary);
    z-index: 999;
    max-height: 300px;
    overflow: auto;
    border-radius: 5px;
    border: 1px solid var(--border-color);
    top: 45px;
    left: 0;
    &.dropup {
      top: auto !important;
      bottom: 50px !important;
    }
    &:last-child {
      border-bottom: 0 !important;
    }
    .option {
      border-bottom: 1px solid var(--border-color);
      padding: 10px;
      &:hover {
        background-color: var(--border-color);
        cursor: pointer;
      }
      p {
        margin: 0;
      }
    }
  }
}
.time-filters-window {
  display: flex;
  flex-direction: column;
  .title {
    margin: 10px 0;
  }
  .rotate {
    transform: rotate(180deg);
  }
  .section-header {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 10px;
    padding: 10px 0px 5px 10px;
    justify-content: space-between;
    border-bottom: 1px solid var(--border-color);
    &:last-child {
      border: 0;
    }
    i {
      transition: 0.3s transform ease-in-out;
    }
    &:hover {
      cursor: pointer;
      opacity: 0.7;
      transition: 0.3s opacity ease-in-out;
    }
  }
  .section-title {
    font-weight: bold;
    display: flex;
    align-items: center;
    i {
      margin-right: 7px;
    }
  }
  .slider-component {
    padding: 15px 10px 20px 10px;
    .am-pm {
      display: flex;
      justify-content: space-between;
      margin-bottom: 10px;
    }
  }
}
</style>
